import React, { useEffect, useState } from 'react';
import { IPermissionsForRoleProps } from './PermissionsForRole.types';
import { IRoleDetails } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';
import { useLayoutContext } from '../../../Context/Layout.context';
import { getRoleWithPermissions } from '../../../services/rolesAndPermissions/rolesAndPermissions.service';
import { AxiosResponse } from 'axios';
import { PermissionsEdit } from './PermissionsEdit.component';
import { comparePermissionsByName } from './helpers';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';

export const PermissionsForRole: React.FC<IPermissionsForRoleProps> = ({ roleId, onClose, onUpdate }) => {
  const [roleWithPermissions, setRoleWithPermissions] = useState<IRoleDetails | undefined>(undefined);
  const { showLoader, openAlert } = useLayoutContext();
  useDocumentTitle('Zarządzaj uprawnieniami');

  useEffect(() => {
    showLoader(true);
    getRoleWithPermissions(roleId)
      .then(
        (response: AxiosResponse<IRoleDetails>) => {
          const data = response.data;
          data.permissions.sort(comparePermissionsByName);
          setRoleWithPermissions(data);
        },
        () => {
          openAlert('get_error');
        },
      )
      .finally(() => {
        showLoader(false);
      });
  }, []);

  if (!roleWithPermissions) {
    return <></>;
  } else
    return (
      <PermissionsEdit
        roleId={roleId}
        roleWithPermissions={roleWithPermissions}
        onClose={onClose}
        onUpdate={onUpdate}
      />
    );
};
